import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'actionArrayFilter'
})
export class ActionFilterPipe implements PipeTransform {

  transform(value: string, lenght?: number): any {
    if (!value) return;
    let availableLength = (lenght) ? lenght : 30;
    if(value.length < availableLength) return value;
    return value.substring(0, availableLength) + ' ... ';
  }

}
